export function runAnimation(transform, duration) {
  var start = performance.now();
  requestAnimationFrame(function animationCallback(time) {
    var progress = (time - start) / duration;
    if (progress > 1) {
      progress = 1;
    }
    transform(progress);
    if (progress < 1) {
      requestAnimationFrame(animationCallback);
    }
  });
}